function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="11" viewBox="0 0 15 11" xmlns="http://www.w3.org/2000/svg" {...props}><title>down-arrow</title><path d="M8.291 9.976l6.464-8.365A1 1 0 0 0 13.964 0H1.036a1 1 0 0 0-.79 1.611l6.463 8.365a1 1 0 0 0 1.582 0z" fill="#D7DBE9" fillRule="evenodd" /></svg>;
});